import styled from 'styled-components';
import { Text12ExtraBold, Text14Regular, Text18Bold } from '../utils/Text/Text.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.6rem;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  gap: 1.2rem;

  svg {
    min-width: 5.4rem;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const Title = styled(Text18Bold)`
  line-height: 22px;
  letter-spacing: -0.072px;
`;

export const Tag = styled.div`
  border-radius: 6px;
  border: 1px solid #97c9f1;
  background: #d8eaf9;
  width: 7rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TagText = styled(Text12ExtraBold)`
  color: #1775be;
  font-weight: 500;
  letter-spacing: 0.48px;
  text-transform: uppercase;
`;

export const Text = styled(Text14Regular)`
  line-height: 22px;
  letter-spacing: 0.07px;
`;
